import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './ProductFamilyBenefits.css';
import { useWidthContext } from '../../providers/Width';
import { Row, Col, Title, Image, Section } from '../../importCL';

interface IContentProps {
    imagePath?: string;
    imageAltText?: string;
    imageDescription?: string;
}

interface IProductFamilyBenefitsProps extends MappedComponentProperties {
    title?: string;
    subtitle?: string;
    desktopImage?: string;
    mobileImage?: string;
    content?: IContentProps[];
}

export const ProductFamilyBenefitsEditConfig = {
    emptyLabel: 'Product Family Benefits',
    isEmpty: (props: PropsWithChildren<IProductFamilyBenefitsProps>) => {
        return !props || !props.title;
    },
};

const ProductFamilyBenefits = (props: PropsWithChildren<IProductFamilyBenefitsProps>): JSX.Element => {
    const { width } = useWidthContext();
    const backgroundImage = width <= 768 ? props.mobileImage : props.desktopImage;
    return (
        <Section id='product-family-benefits' className='ProductFamilyBenefits' bgImg={backgroundImage}>
            <div>
                <Title className='mb-6' showHr tag='h2'
                    align='center'>{transformHTMLParserLinks(props.title ?? '')}</Title>
                <Row>
                    <Col className='ProductFamilyBenefits__Col' xs={12}>
                        {props.subtitle &&
                        <p className='ProductFamilyBenefits__subtitle'>{transformHTMLParserLinks(props.subtitle)}</p>}
                        <div className='ProductFamilyBenefits__content mb-6'>
                            <Row>
                                {(props.content && props.content.length > 0) && props.content.map((item, index) => {
                                    return (
                                        <Col md={6} lg={4} className='ProductFamilyBenefits__content--item my-4' key={index}>
                                            <Image loading='lazy' className='ProductFamilyBenefits__image' src={item.imagePath}
                                                alt={item.imageAltText}/>
                                            {item.imageDescription &&
                                            <p className='ProductFamilyBenefits__text'>
                                                {transformHTMLParserLinks(item.imageDescription)}
                                            </p>}
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        </Section>
    );
};

export default ProductFamilyBenefits;